// Copyright 2024 Sorama B.V.

export class HarmonicSelectionModes {
    public static evenAndOdd = "All";
    public static peak = "Peak";
    public static none = "None";

    public static all: string[] = [
        HarmonicSelectionModes.evenAndOdd,
        HarmonicSelectionModes.peak,
        HarmonicSelectionModes.none,
    ];
}

export type HarmonicSelectionMode = (typeof HarmonicSelectionModes.all)[number];
